import { findClosestElementByClass } from "../helpers/dom/closest";
import requestHelper from "../../plugins/requestHelper";
import { NetiaGoogleMap } from "../google-map/gm";
import { PosTabs } from "./posTabs";
import { SendForm } from "../ajaxForm/ajax";
import { getOffsetTop } from "../../plugins/scrollTo";

export class POS {
	constructor(node) {
		this.root = node;
		this.mapNode = node.querySelector("[data-pos-map]");
		this.invest = this.mapNode.hasAttribute("data-pos-invest");
		this.dataUrl = this.mapNode.getAttribute("data-pos-map-url");
		this.filtersArr = [];
		this.initMap();
		this.search = this.root.querySelector("[data-pos-search]");
		this.results = this.root.querySelector("[data-pos-results]");
		this.results_con = this.root.querySelector("[data-pos-results-con]");
		this.noresults_con = this.root.querySelector("[data-pos-noresults-con]");
	}

	setMapEvents() {
		const checkboxes = this.root.querySelectorAll("[data-pos-cb]");
		for (let i = 0; i < checkboxes.length; i++) {
			const cb = checkboxes[i];
			cb.addEventListener("change", () => {
				this.changeCheckbox(cb);
			});
		}
		const localizationButton = this.root.querySelector("[data-pos-loc]");
		localizationButton.addEventListener("click", (e) => {
			e.preventDefault();
			this.getLocation();
		});

		const posCity = this.root.querySelectorAll("[data-pos-city]");
		for (let i = 0; i < posCity.length; i++) {
			const city = posCity[i];
			city.addEventListener("click", () => {
				this.resetCheckboxes();
				this.map.filterMarkersInCity(city.getAttribute("data-pos-city"));
				this.showResults();
				// this.map.showPosition(parseInt(city.getAttribute('data-pos-zoom')), { lat: parseFloat(city.getAttribute('data-pos-latitude')), lng: parseFloat(city.getAttribute('data-pos-longitude')) });
				// alert(google.maps.geometry.spherical.computeDistanceBetween(new google.maps.LatLng(53.128816, 23.128462), new google.maps.LatLng(parseFloat(city.getAttribute('data-pos-latitude')), parseFloat(city.getAttribute('data-pos-longitude')))));
			});
		}

		const zipButton = this.root.querySelector("[data-pos-button-zipcode]");
		const zipInput = this.root.querySelector("#zipcode");
		const form = findClosestElementByClass(zipInput, "form-group");
		const constraints = {
			zipcode: {
				presence: {
					message: "^" + zipInput.getAttribute("data-error-invalid"),
				},
				length: {
					minimum: 6,
					message: "^" + zipInput.getAttribute("data-error-invalid"),
				},
			},
		};
		zipButton.addEventListener("click", () => {
			const errors = validate(form, constraints);
			// console.log(errors, form);
			this.SendForm = new SendForm(this.root);
			this.SendForm.showErrors(form, errors || {});
			if (!errors) {
				this.showPointsInZipLocation(this);
			}
		});
	}

	changeCheckbox(cb) {
		const isChecked = cb.checked;
		const cbValue = cb.getAttribute("data-pos-cb");
		const thValIndex = this.filtersArr.indexOf(cbValue);

		if (isChecked && thValIndex === -1) {
			this.filtersArr.push(cbValue);
		}

		if (!isChecked && thValIndex !== -1) {
			this.filtersArr.splice(thValIndex, 1);
		}
		this.map.filterMarkers(this.filtersArr);
		// console.log(this.filtersArr, this.map.mapMarkersVisible);
	}

	showPointsInZipLocation(that) {
		let lat = "";
		let lng = "";
		const address = this.root.querySelector("#zipcode").value + ", Polska";
		const geocoder = new google.maps.Geocoder();
		geocoder.geocode(
			{
				address: address,
			},
			function (results, status) {
				// console.log(status, google.maps.GeocoderStatus.OK);
				if (status == google.maps.GeocoderStatus.OK) {
					lat = results[0].geometry.location.lat();
					lng = results[0].geometry.location.lng();
					that.resetCheckboxes();
					that.map.filterMarkersInLocalization(
						new google.maps.LatLng(
							results[0].geometry.location.lat(),
							results[0].geometry.location.lng()
						),
						that.distance
					);
					that.showResults();
					//  alert('Latitude: ' + lat + ' Logitude: ' + lng);
				} else {
					that.map.mapMarkersVisible = [];
					that.showResults();
					// alert("Geocode was not successful for the following reason: " + status);
				}
			}
		);
	}

	getLocation() {
		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(this.showPosition.bind(this));
		} else {
			alert("Geolocation is not supported by this browser.");
		}
	}

	showPosition(position) {
		// console.log(this);
		// alert("Latitude: " + position.coords.latitude + "<br>Longitude: " + position.coords.longitude);
		this.resetCheckboxes();
		this.map.filterMarkersInLocalization(
			new google.maps.LatLng(position.coords.latitude, position.coords.longitude),
			this.distance
		);
		this.showResults();
	}

	showResults() {
		this.search.classList.add("hide");
		this.results.classList.remove("hide");
		const that = this;
		this.results_con.innerHTML = "";
		if (this.map.mapMarkersVisible.length > 0) {
			this.results.setAttribute("role", "alert");
			setTimeout(function () {
				that.results.focus();
			}, 100);
			this.noresults_con.classList.add("hide");
			this.results_con.classList.remove("hide");
			let posList = document.createElement('ul');
			posList.setAttribute("role", "list");
			posList.classList.add("pos__tabs__content_vwcity-list");
			this.map.mapMarkersVisible.forEach((pos) => {
				this.results_con.appendChild(posList);
				posList.innerHTML += `<li role="option"><button type="button" class="info-base__btnlink" data-pos-id='${
					pos.id
				}' data-pos-lat-lng='{ "lat": ${pos.latitude}, "lng": ${pos.longitude} }'>
						${this.invest ? pos.title : pos.address}
					</button><li>`;
			});
			const posOffice = this.root.querySelectorAll("[data-pos-lat-lng]");
			posOffice.forEach((office) => {
				office.addEventListener("click", () => {
					this.map.showPosition(
						16,
						JSON.parse(office.getAttribute("data-pos-lat-lng"))
					);
					this.map.openInfoWindow(office.getAttribute("data-pos-id"));
					if (
						document.body.classList.contains("is-mobile") ||
						document.body.classList.contains("is-tablet")
					) {
						$("html, body").animate(
							{
								scrollTop: getOffsetTop(this.root.querySelector(".pos__map")) - 80,
							},
							300
						);
					}
				});
			});
			this.focusToPopup();
		} else {
			this.results_con.classList.add("hide");
			this.noresults_con.classList.remove("hide");
			setTimeout(function () {
				that.noresults_con.firstChild.tabIndex = -1;
				that.noresults_con.firstChild.setAttribute("role", "alert");
				that.noresults_con.firstChild.focus();
			}, 500);
		}

		const backButton = this.root.querySelector("[data-pos-result-back]");
		backButton.addEventListener("click", () => {
			this.results.removeAttribute("role");
			this.noresults_con.firstChild.removeAttribute("role");
			this.search.classList.remove("hide");
			const that = this;
			setTimeout(function () {
				that.search.focus();
			}, 100);
			this.results.classList.add("hide");
			this.map.resetMap();
		});
	}

	//Focus to Marker when clicked to link
	focusToPopup() {
		let buttons = [...this.results_con.children];

		buttons.forEach((button) => {
			button.addEventListener("click", (el) => {
				let popup = document.querySelector(".pos__infowin"),
					searchPopup = setInterval(() => {
						if (!popup) {
							popup = document.querySelector(".pos__infowin");
						} else {
							clearInterval(searchPopup);
							popup.focus();
							closePopup(button);
						}
					}, 400);
			});
		});

		//After close popup, activate focus to previus clicked button
		function closePopup(button) {
			let closeButton = document.querySelector(
				".pos__mapbox button.gm-ui-hover-effect"
			);
			closeButton.addEventListener("click", () => {
				button.focus();
			});
		}
	}

	resetCheckboxes() {
		const checkboxes = this.root.querySelectorAll("[data-pos-cb]");
		for (let i = 0; i < checkboxes.length; i++) {
			const cb = checkboxes[i];
			cb.checked = false;
			this.changeCheckbox(cb);
			// var event = new Event('change');
			// cb.dispatchEvent(event);
		}
	}

	displayVoivodeships(data) {
		const voivodeships = this.root.querySelectorAll("[data-pos-vwcity]");
		let selectVoiv = document.createElement('ul');
		selectVoiv.setAttribute("role", "list");
		selectVoiv.classList.add("pos__tabs__content_vwcity-list");
		data.voivodeships.forEach((element) => {
			voivodeships[0].appendChild(selectVoiv);
			selectVoiv.innerHTML =
				selectVoiv.innerHTML +
				`<li role="option"><button type="button" class="info-base__btnlink" data-pos-vw="${element.id}" value="${element.id}">
          <span class="sr-only">województwo </span>${element.name}
        </button></li>`;
			voivodeships[1].innerHTML =
				voivodeships[1].innerHTML +
				`<div data-pos-vw="${element.id}" class="hide"></div>`;
		});
		const cities = voivodeships[1].querySelectorAll("[data-pos-vw]");
		let selectCity = document.createElement('ul');
		selectCity.setAttribute("role", "list");
		selectCity.classList.add("pos__tabs__content_vwcity-list");
		data.cities.forEach((element) => {
			cities.forEach((city) => {
				if (element.voivodeship == city.getAttribute("data-pos-vw")) {
					// console.log(element.id);
					city.appendChild(selectCity);
					selectCity.innerHTML =
						selectCity.innerHTML +
						`
            <li role="option"><button type="button" class="info-base__btnlink" data-pos-city="${element.id}" value="${element.id}">
                <span class="sr-only">miasto </span>${element.name}
            </button></li>`;
				}
			});
		});
	}

	initMap() {
		this.map = new NetiaGoogleMap(this.mapNode);
		this.getPos();
	}

	getPos() {
		requestHelper
			.request("get", this.dataUrl, null)
			.then((res) => {
				const data = JSON.parse(res);
				this.map.initPosTypes(data.posTypes);
				this.map.initMarkers(data.pos);
				this.displayVoivodeships(data);
				this.distance = data.distance;

				// tabsy
				this.posTabs = new PosTabs(this.root);
				this.setMapEvents();
			})
			.catch((e) => console.log(e));
	}
}
